import { type ReactNode } from "react";

export const SHIRT_TAB_IDS = {
  FRONT: "front",
  BACK: "back"
} as const;

export type TabId = (typeof SHIRT_TAB_IDS)[keyof typeof SHIRT_TAB_IDS];

export type TabItem = {
  id: TabId;
  label: string;
  icon: ReactNode;
  testId: string;
};

export type TabNavigationProps = {
  tabs: TabItem[];
  activeTab: TabId;
  onTabChange: (tabId: TabId) => void;
  className?: string;
};

export type TabProps = {
  tab: TabItem;
  isActive: boolean;
  onClick: () => void;
};
